import * as React from 'react';
import { MessageBar, MessageBarType } from '@fluentui/react';
import CopyToClipboard from './CopyToClipboard';
import './StatusIcon.scss';
import { uuidv4 } from './uuidv4';

interface IRenderListProps {
  fieldName: string;
  listText: any;
}

interface IDoc {
  tenantId: string;
  transactionId: string;
  Date: string;
  domain: string;
  Id: string;
}

interface IRenderListState {
  errorMessage: string | null;
}

export class RenderList extends React.Component<IRenderListProps, IRenderListState> {
  constructor(props: IRenderListProps) {
    super(props);
    this.state = {
      errorMessage: null
    };
  }
  public render() {
    const { fieldName } = this.props;
    const { errorMessage } = this.state;

    return (
      <>
        {errorMessage && (
          <MessageBar
            messageBarType={MessageBarType.error}
            isMultiline={true}
            onDismiss={() => this.setState({ errorMessage: null })}
            dismissButtonAriaLabel="Close"
          >
            {errorMessage}
          </MessageBar>
        )}
        {this.renderContent(fieldName)}
      </>
    );
  }

  private async downloadDocument(doc: { name: string; id: string }): Promise<void> {
    try {
      // Import dynamically to avoid module-level initialization in tests
      const authenticationService = (await import('../../dataServices/AuthenticationService')).default;
      const { httpRequest } = await import('../../common/utilities/HttpRequest');
      
      const apiUrl = `${process.env.REACT_APP_INTERNAL_API_BASEURL}/documents/admin/download/${doc.id}`;
      const token = await authenticationService.getToken();
      
      const response = await httpRequest(apiUrl, token ?? undefined, undefined, 'GET');
      
      if (!response.ok) {
        const errorMsg = `Error: Failed to download document ${doc.name}. Please try again.`;
        this.setState({ errorMessage: errorMsg });
        return;
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = doc.name || 'document';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      const errorMsg = `Error: Failed to download document ${doc.name}. Please try again.`;
      this.setState({ errorMessage: errorMsg });
    }
  }

  private renderContent(fieldName: string) {
    return {
      domain: this.props.listText.map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.domain} <CopyToClipboard textToCopy={doc.domain} />
        </p>
      )),
      domainFromDocuments: this.props.listText.map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.Id} <CopyToClipboard textToCopy={doc.Id} />
        </p>
      )),
      tenantId: this.props.listText.map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.tenantId} <CopyToClipboard textToCopy={doc.tenantId} />
        </p>
      )),
      tenantIdFromDocuments: this.props.listText.map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.Id} <CopyToClipboard textToCopy={doc.Id} />
        </p>
      )),
      transactionId: this.props.listText.map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.transactionId} <CopyToClipboard textToCopy={doc.transactionId} />
        </p>
      )),
      transactionIdsFromDocuments: sortedTransactions(this.props.listText).map((doc: IDoc) => (
        <p key={uuidv4()}>
          {doc.Id}
          <CopyToClipboard textToCopy={doc.Id} /> <br />
          <i>{doc.Date}</i>
        </p>
      )),
      supportingDocuments: this.props.listText.map((doc: { name: string; id: string }) => (
        <p key={uuidv4()}>
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              this.downloadDocument(doc);
            }}
            style={{ fontSize: 'inherit' }}
          >
            {doc.name}
          </a>{' '}
          <CopyToClipboard textToCopy={doc.name} />
        </p>
      )),
      supportingDocumentsPlain: this.props.listText.map((doc: { name: string; id: string }) => (
        <p key={uuidv4()}>
          {doc.name}{' '}
          <CopyToClipboard textToCopy={doc.name} />
        </p>
      ))
    }[fieldName];
  }
}

// custom comparator to sort the transactions by date. The latest transaction will be on top.
export function sortedTransactions(list: any): any {
  list.sort((a: any, b: any) => {
    if (a.Date > b.Date) {
      return -1;
    } else if (a.Date < b.Date) {
      return 1;
    }

    return 0;
  });

  return list;
}

export default RenderList;
